import type { TodayItem } from '../services/MendsVisionService';

/** Extrai o id numérico da aprovação a partir do item today-v2 (appr-N / risk-appr-N / ?id=N). */
export function todayApprovalId(item: Pick<TodayItem, 'id' | 'kind' | 'actionPath'>): number | null {
  const fromId = /^(?:appr|risk-appr)-(\d+)$/i.exec(item.id || '');
  if (fromId) return Number(fromId[1]);
  const fromPath = /[?&]id=(\d+)/i.exec(item.actionPath || '');
  if (fromPath) return Number(fromPath[1]);
  return null;
}

export function isTodayDecisionItem(item: Pick<TodayItem, 'kind'>): boolean {
  return item.kind === 'approval' || item.kind === 'risk_approval_stale';
}
